var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('subscription-type-button',{attrs:{"selected":_vm.selected,"subscription-type":_vm.SUBSCRIPTION_TYPES.MONTHLY,"main-text":'מינוי חודשי',"sub-text":'חיוב חודשי',"price":_vm.totalMonthlyPricingPerYear,"sub-price":_vm.pricing.monthly.toString()},on:{"subscription-type-selected":function () {
	var ref;

	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];
	return (ref = this$1).$emit.apply(ref, [ 'subscription-type-selected' ].concat( args ));
}}})}
var staticRenderFns = []

export { render, staticRenderFns }